<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="remarks"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td></td>
            <td
              class="th-plugin-line--remove th-plugin-line--remove-customer"
              style="width: 50%"
              colspan="2"
              align="right"
            >
              <i class="material-icons" (click)="openCommentDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.comment.to' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <p
                  class="ir-required th-required visible"
                  [class.visible]="
                    !(item.controls.Type.value || item.controls.Type.value === 0) || item.controls.Type.value === -1
                  "
                >
                  <span>{{ 'common.required' | translate }}</span>
                </p>
                <input type="hidden" class="ir-form-set" formControlName="Type" />
                <div class="ir-line ir-select th-select" (click)="openTypesSelector(item.controls.Type.value, i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      (item.controls.Type.value || item.controls.Type.value === 0) && item.controls.Type.value !== -1
                        ? (item.controls.Type.value | commenttype)
                        : ('plugins.comment.select-comment-type' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.comment.icon' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <p
                  class="visible"
                  [class.visible]="
                    !(item.controls.Icon.value || item.controls.Icon.value === 0) || item.controls.Icon.value === -1
                  "
                ></p>
                <input type="hidden" class="ir-form-set" formControlName="Icon" />
                <div class="ir-line ir-select th-select" (click)="openIconsSelector(item.controls.Icon.value, i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span style="display: inline" class="label">{{ item.controls.Icon.value | iconType }}</span>
                    <i class="material-icons" style="position: absolute">{{ item.controls.Icon.value | icon }}</i>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'plugins.comment.comment' | translate }} *</span>
        </h2>
        <div class="ir-form-group" [formGroupName]="i">
          <p class="ir-required th-required visible" [class.visible]="!item.controls.Comment.value">
            <span>{{ 'common.required' | translate }}</span>
          </p>
          <textarea
            id="text"
            formControlName="Comment"
            rows="3"
            placeholder="{{ 'plugins.comment.your-comment' | translate }}"
            class="ir-form-set"
          ></textarea>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<modal (modalOutput)="selectTypesMenu($event)" (modalClosed)="onClose($event)" #typesModal></modal>
<modal (modalOutput)="selectIconsMenu($event)" (modalClosed)="onClose($event)" #iconsModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #commentDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>comment</strong>?'"
  [danger]="true"
></confirm>
